export const shouldShowDeliveryDiscountMessage = (
  message?: string | null
): boolean => {
  if (!message || !message.trim()) {
    return false;
  }

  const normalizedMessage = message.trim().toLowerCase();

  return !normalizedMessage.includes("no delivery discount available");
};
